<template>
  <el-container v-loading="loading">
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listQuerenBtn">确认</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listYiyiBtn">异议</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>

      <el-main>
        <!-- 表头（详情/编辑） -->
        <el-form
          v-if="viewMode == 'info'"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_storeCode'"
                v-model="data.head['storeCode']"
                url="base/user/user/store/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="storeCode"
                name="门店编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_storeName'"
                v-model="data.head['storeName']"
                code="storeName"
                name="门店名称"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_robotCode'"
                v-model="data.head['robotCode']"
                url="base/user/robot/robot/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="robotCode"
                name="机器人编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_robotName'"
                v-model="data.head['robotName']"
                code="robotName"
                name="机器人名称"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_month'"
                v-model="data.head['month']"
                code="month"
                name="结算月份"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-datetime
                :ref="'input_startTime'"
                v-model="data.head['startTime']"
                code="startTime"
                name="开始时间"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-datetime
                :ref="'input_endTime'"
                v-model="data.head['endTime']"
                code="endTime"
                name="结束时间"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_amount'"
                v-model="data.head['amount']"
                code="amount"
                name="流水金额"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_storeAmount'"
                v-model="data.head['storeAmount']"
                code="storeAmount"
                name="门店金额"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_channelAmount'"
                v-model="data.head['channelAmount']"
                code="channelAmount"
                name="渠道金额"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_groupAmount'"
                v-model="data.head['groupAmount']"
                code="groupAmount"
                name="集团金额"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_stateSign'"
                v-model="data.head['stateSign']"
                code="stateSign"
                name="状态标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.stateSign)"
                :disabled="false"
              />
            </el-col>
          </el-row>
        </el-form>

        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <el-form
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'search_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'search_storeCode'"
                      v-model="searcher['storeCode']"
                      url="base/user/user/store/find/findPagination"
                      :filed-list="[
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="name"
                      :searcher="{}"
                      code="storeCode"
                      name="门店编码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'search_storeName'"
                      v-model="searcher['storeName']"
                      code="storeName"
                      name="门店名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-data-popup
                      :ref="'search_robotCode'"
                      v-model="searcher['robotCode']"
                      url="base/user/robot/robot/find/findPagination"
                      :filed-list="[
                        { code: 'id', name: 'Id' },
                        { code: 'code', name: '编码' },
                        { code: 'name', name: '名称' }
                      ]"
                      search-key="name"
                      :searcher="{}"
                      code="robotCode"
                      name="机器人编码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                      @onPopupClick="searchPopupClick"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'search_robotName'"
                      v-model="searcher['robotName']"
                      code="robotName"
                      name="机器人名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'search_snCode'"
                      v-model="searcher['snCode']"
                      code="snCode"
                      name="序列号"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'search_pushCode'"
                      v-model="searcher['pushCode']"
                      code="pushCode"
                      name="推送识别号"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'search_robotModelCode'"
                      v-model="searcher['robotModelCode']"
                      code="robotModelCode"
                      name="设备型号"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-text code="code" name="编码" :edit="false" />
          <ik-column-text code="storeCode" name="门店编码" :edit="false" />
          <ik-column-text code="storeName" name="门店名称" :edit="false" />
          <ik-column-text code="robotCode" name="机器人编码" :edit="false" />
          <ik-column-text code="robotName" name="机器人名称" :edit="false" />
          <ik-column-text code="month" name="结算月份" :edit="false" />
          <ik-column-datetime code="startTime" name="开始时间" :edit="false" />
          <ik-column-datetime code="endTime" name="结束时间" :edit="false" />
          <ik-column-text code="amount" name="流水金额" :edit="false" />
          <ik-column-text code="storeAmount" name="门店金额" :edit="false" />
          <ik-column-text code="channelAmount" name="渠道金额" :edit="false" />
          <ik-column-text code="groupAmount" name="集团金额" :edit="false" />
          <ik-column-select
            code="stateSign"
            name="状态标识"
            :edit="false"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.stateSign)"
          />
        </el-table>
      </el-main>

      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkFormDatetime from '@/components/ik/form/input/IkFormDatetime'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkPagination from '@/components/ik/pagination/IkPagination'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkColumnDatetime from '@/components/ik/table/ikColumn/IkColumnDatetime'
import store from '@/store'

import { getById, findPage, save, update, remove } from '@/api/ik/data/dataApi'

export default {
  components: {
    IkFormText,
    IkFormDataPopup,
    IkFormSelect,
    IkColumnText,
    IkPagination,
    IkColumnDatetime,
    IkFormDatetime,
    IkColumnSelect
  },
  data() {
    return {
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      bgPath: 'clinic/settlement/billing/physicalbilling',
      webPath: 'settlement/physicalBilling',
      jsonStr: {
        stateSign: '[{"key": "1", "value": "未确认"}, {"key": "2", "value": "已确认"}, {"key": "3", "value": "已打款"}]'
      },
      viewMode: '',
      mode: '',
      loading: false,
      listLoading: false,
      searcherActive: "0",
      searcher: {},
      tableData: [],
      activeRow: {},
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0
      },
      data: {
        head: {},
        body: {}
      },
      bodyMap: [],
      validate: [],
      bodyValidate: [],
      activeTab: '',
      verify: {
        head: {},
        body: {}
      }
    }
  },
  created() {
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // 列表页详情按钮
    listDetailsBtn() {
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要查看详情的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页确认按钮
    listQuerenBtn() {
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要确认的行!'
        })
        return
      }
      if ($this.activeRow.stateSign === '2' || $this.activeRow.stateSign === 2) {
        $this.$message({
          type: 'warning',
          message: '该数据已确认，无需重复操作!'
        })
        return
      }
      $this.$confirm('确认该笔流水？确认后状态将变为已确认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getById($this.bgPath, $this.activeRow.id).then(response => {
          const updateData = response.data
          updateData.head.stateSign = '2'
          update($this.bgPath, updateData).then(() => {
            $this.$message({
              type: 'success',
              message: '确认成功!'
            })
            $this.find()
          })
        })
      }).catch(() => {})
    },
    // 列表页异议按钮
    listYiyiBtn() {
      this.$alert('请联系客服：17717689571', '异议', {
        confirmButtonText: '确定',
        type: 'info'
      })
    },
    infoDetailsBtn() {
      this.mode = "details"
      this.get(this.data.head.id)
    },
    infoCancelBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },
    searchBtn() {
      this.find()
    },
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    rowClick(row) {
      this.activeRow = row
    },
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    pageChange(pageNo, pageSize) {
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      this.find()
    },
    searchPopupClick(code, row) {
      if (code === 'storeCode') {
        this.searcher['storeCode'] = row.code
        this.searcher['storeName'] = row.name
      } else if (code === 'robotCode') {
        this.searcher['robotCode'] = row.code
        this.searcher['robotName'] = row.name
      }
    },
    headPopupClick(code, row) {
      if (code === 'storeCode') {
        this.data.head['storeId'] = row.id
        this.data.head['storeCode'] = row.code
        this.data.head['storeName'] = row.name
      } else if (code === 'robotCode') {
        this.data.head['robotId'] = row.id
        this.data.head['robotCode'] = row.code
        this.data.head['robotName'] = row.name
      }
    },
    saveOrUpdate() {
      const $this = this
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          $this.id = response.data
          $this.get(response.data)
          $this.$message({ type: 'success', message: '数据已保存!' })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          $this.id = response.data
          $this.get(response.data)
          $this.$message({ type: 'success', message: '数据已保存!' })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({ type: 'warning', message: '数据已删除!' })
        $this.find()
      })
    },
    get(id) {
      const $this = this
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    find() {
      const $this = this
      $this.listLoading = true
      $this.searcher.storeCode = $this.storeCode
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        $this.tableData = response.data.list
        $this.pagination.totalCount = response.data.totalCount
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    }
  }
}
</script>

<style lang="scss" >
@import "~@/styles/listinfo.scss";
</style>
